var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-guests-badge d-flex align-center",class:{ 'gst-guests-badge--dark-mode': _vm.darkMode }},[_c('BaseIcon',{attrs:{"symbol-id":"icons--user"}}),_vm._v(" x"+_vm._s(_vm.numberOfGuests)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }